var _circle, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermAndConditionFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4892_86086",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 12,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.666 5.32812H8.33268C8.15587 5.32812 7.9863 5.39836 7.86128 5.52339C7.73625 5.64841 7.66602 5.81798 7.66602 5.99479V17.9948C7.66602 18.1716 7.73625 18.3412 7.86128 18.4662C7.9863 18.5912 8.15587 18.6615 8.33268 18.6615H17.666C17.8428 18.6615 18.0124 18.5912 18.1374 18.4662C18.2624 18.3412 18.3327 18.1716 18.3327 17.9948V5.99479C18.3327 5.81798 18.2624 5.64841 18.1374 5.52339C18.0124 5.39836 17.8428 5.32812 17.666 5.32812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39052 5.05459C7.64057 4.80454 7.97971 4.66406 8.33333 4.66406H17.6667C18.0203 4.66406 18.3594 4.80454 18.6095 5.05459C18.8595 5.30464 19 5.64378 19 5.9974V17.9974C19 18.351 18.8595 18.6902 18.6095 18.9402C18.3594 19.1903 18.0203 19.3307 17.6667 19.3307H8.33333C7.97971 19.3307 7.64057 19.1903 7.39052 18.9402C7.14048 18.6902 7 18.351 7 17.9974V5.9974C7 5.64377 7.14048 5.30463 7.39052 5.05459ZM17.6667 5.9974H8.33333L8.33333 17.9974H17.6667V5.9974Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4714 7.85932C15.7318 8.11967 15.7318 8.54178 15.4714 8.80213L12.8047 11.4688C12.5444 11.7291 12.1223 11.7291 11.8619 11.4688L10.5286 10.1355C10.2682 9.87512 10.2682 9.45301 10.5286 9.19266C10.7889 8.93231 11.2111 8.93231 11.4714 9.19266L12.3333 10.0546L14.5286 7.85932C14.7889 7.59898 15.2111 7.59898 15.4714 7.85932ZM10 13.9974C10 13.6292 10.2985 13.3307 10.6667 13.3307H15.3333C15.7015 13.3307 16 13.6292 16 13.9974C16 14.3656 15.7015 14.6641 15.3333 14.6641H10.6667C10.2985 14.6641 10 14.3656 10 13.9974ZM10 15.9974C10 15.6292 10.2985 15.3307 10.6667 15.3307H13C13.3682 15.3307 13.6667 15.6292 13.6667 15.9974C13.6667 16.3656 13.3682 16.6641 13 16.6641H10.6667C10.2985 16.6641 10 16.3656 10 15.9974Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4892_86086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4H21V20H5V4Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermAndConditionFilledIcon);
export default __webpack_public_path__ + "static/media/term-and-condition-filled-icon.886f7b8d2853dcd9f03f002bfa4fee19.svg";
export { ForwardRef as ReactComponent };